import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b1b370886e100014df5b54/cakepalace/src/app/cart/page.tsx");
